import { GenerateChartIcon, WorkflowsIcon, NotificationIcon, ContactsIcon, WebsiteIcon, DynamicFilterIcon, FileIcon, EmailIcon, SettingsIcon, IntegrationsIcon } from 'foundations-assets';
export const ScopeCategoryIcon = {
  analytics: 'generateChart',
  automation: 'workflows',
  'communication-preferences': 'notification',
  crm: 'contacts',
  cms: 'website',
  events: 'dynamicFilter',
  files: 'file',
  marketing: 'email',
  settings: 'settings',
  other: 'integrations'
};
export const UIICON_NAME_TO_FOUNDATIONS_ICON_MAP = {
  generateChart: GenerateChartIcon,
  workflows: WorkflowsIcon,
  notification: NotificationIcon,
  contacts: ContactsIcon,
  website: WebsiteIcon,
  dynamicFilter: DynamicFilterIcon,
  file: FileIcon,
  email: EmailIcon,
  settings: SettingsIcon,
  integrations: IntegrationsIcon
};